import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ClientAgreementTemplateBO } from './clienttemplate.model';
import { ErrorService } from 'src/app/error.service';
import { GlobalComponent } from 'src/app/global/global.component';

@Injectable({
  providedIn: 'root'
})

export class clienttemplateService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  constructor(private http: HttpClient, public errorService: ErrorService , public global : GlobalComponent) { }


  getSaveonBoardProfileAgency(params: URLSearchParams): Observable<any> {
    let url = "api/ClientProfile/getOnboardClientProfile?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getonBoardAgency(params: URLSearchParams): Observable<any> {
    let url = "api/ClientAgreement/GetClientTemplateForAgency?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getonBoardclient(): Observable<any> {
    let url = "api/OnboardClientsDocument/GetMyDocument?"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getOnboardProfile(): Observable<any> {
    let url = "api/ClientProfile/getMyProfile?"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  gettype(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/LOV/getLovDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getcomman(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/OnboardingContactInfo/getLovDropdownForOnboard?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveClientAgency(saveDocument: ClientAgreementTemplateBO): Observable<any> {
    let url = "api/ClientAgreement/SaveClientTemplateForAgency";
    return this.http.post<any>(url, saveDocument, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveClientOnboard(saveDocument: ClientAgreementTemplateBO): Observable<any> {
    let url = "api/OnboardClientsDocument/SaveMyOnboardDocument";
    return this.http.post<any>(url, saveDocument, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getDocumentList(params: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/OnboardingContactInfo/getLovDropdownForOnboard?";
    return this.http.get<[{ Key: string, Value: string }]>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetAgencyDetails(): Observable<any> {
    let url;
    if(this.global.OnboardingLoginType =='onboardLogin')
      {
         url = "api/Client_ServiceDeliveryPlan/GetAgencyDetails?";
      }
      else{

         url = "api/ClientAgreement/GetAgencyDetails?";
      }
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

}
